exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h3{margin-bottom:10px;margin-top:15px;text-decoration:underline}button.bid-manager-btn{margin-top:5px;margin-bottom:10px}li{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/bid.management.component.css
// module id = 1142
// module chunks = 0